import { cleanCommonParams } from './common';

const mapAgencyParams = (
    isCreate,
    {
        name,
        main_id,
        agents_count,
        ...params
    },
) => {
    return new Promise((resolve) => {
        resolve({
            agency: {
                ...cleanCommonParams(params),
            },
        });
    });
};

export { mapAgencyParams };
